import React from "react";
import styles from "./Associados.module.css";
import { Container, Row, Col } from "react-bootstrap";

// Importar todas as logos dos associados
import altoDaSerra from "../../logos-associados/alto-da-serra.png";
import azeite1244 from "../../logos-associados/azeite-1244.png";
import azeiteMantikir from "../../logos-associados/azeite-mantikir.png";
import azeitePili from "../../logos-associados/azeite-pili.png";
import azeiteRossini from "../../logos-associados/azeite-rossini.png";
import caperucita from "../../logos-associados/caperucita.png";
import casaCalcada from "../../logos-associados/casa-calcada.png";
import casaColombi from "../../logos-associados/casa-colombi.png";
import casaDias from "../../logos-associados/casa-dias.png";
import casaMantiva from "../../logos-associados/casa-mantiva.png";
import colhida from "../../logos-associados/colhida.png";
import donaMariaDaFe from "../../logos-associados/dona-maria-da-fe.png";
import fazendaMariaDaFe from "../../logos-associados/fazenda-maria-da-fe.png";
import fazendaRoseda from "../../logos-associados/fazenda-roseda.png";
import fioDeOuro from "../../logos-associados/fio-de-ouro.png";
import gamarra from "../../logos-associados/gamarra.png";
import grattacielo from "../../logos-associados/grattacielo.png";
import machuPicchu from "../../logos-associados/machu-picchu.png";
import miralua from "../../logos-associados/miralua.png";
import oliq from "../../logos-associados/oliq.png";
import olivabr from "../../logos-associados/olivabr.png";
import olivaisCatasAltas from "../../logos-associados/olivais-catas-altas.png";
import olivaisDeQuelemem from "../../logos-associados/olivais-de-quelemem.png";
import olivasGerais from "../../logos-associados/olivas-gerais.png";
import olivasVikaz from "../../logos-associados/olivas-vikaz.png";
import raiz from "../../logos-associados/raiz.png";
import sabia from "../../logos-associados/sabia.png";
import serraQueChora from "../../logos-associados/serra-que-chora.png";
import sitioDaPedra from "../../logos-associados/sitio-da-pedra.png";
import solarDaOpera from "../../logos-associados/solar-da-opera.png";
import soulMantiqueira from "../../logos-associados/soul-mantiqueira.png";
import trapia from "../../logos-associados/trapia.png";
import veraCruz from "../../logos-associados/vera-cruz.png";
import verdeOliva from "../../logos-associados/verde-oliva.png";
import veroli from "../../logos-associados/veroli.png";

// Array de associados com imagem e URL
const associados = [
  { img: altoDaSerra, name: "Alto da Serra", url: "https://www.instagram.com/altodaserra.oficial?igsh=MTNpazkzZG9la2F5Nw==" },
  { img: azeite1244, name: "Azeite 1244", url: "https://www.azeite1244.com.br" },
  { img: azeiteMantikir, name: "Azeite Mantikir", url: "https://www.essenzastore.com.br" },
  { img: azeitePili, name: "Azeite Pili", url: "https://www.azeitepili.com.br" },
  { img: azeiteRossini, name: "Azeite Rossini", url: "https://www.instagram.com/azeiterossini?igsh=MTVnNnZ5YWpycTVkdg==" },
  { img: caperucita, name: "Caperucita", url: "https://www.instagram.com/agro.caperucita?igsh=azZneW5rMWdtNnp5" },
  { img: casaCalcada, name: "Casa Calçada", url: "https://www.instagram.com/casa.calcadaazeites?igsh=aTZ0NTRxbXhsbGcy" },
  { img: casaColombi, name: "Casa Colombi", url: "https://www.instagram.com/casacolombi?igsh=cjhsYTN2Yml5NTZh" },
  { img: casaDias, name: "Casa Dias", url: "https://www.azeitecasadias.com.br/?fbclid=PAdGRleAODhbdleHRuA2FlbQIxMQBzcnRjBmFwcF9pZA8xMjQwMjQ1NzQyODc0MTQAAact1w2uf_2DcQGVLoih14zb-s51GXo1zmIW81R2IdeBe_7Je_TTjwU0AHDtYw_aem_DHpC7yfiF_8_WZTN2aT7qg" },
  { img: casaMantiva, name: "Casa Mantiva", url: "https://www.instagram.com/casamantiva?igsh=MW9tYWY1aTMxeDVkcQ==" },
  { img: colhida, name: "Colhida", url: "https://colhida.com.br/products/azeite-premium" },
  { img: donaMariaDaFe, name: "Dona Maria da Fé", url: "https://www.instagram.com/azeite_mariadafe?igsh=MWFzZGVlenBwZ254Mw==" },
  { img: fazendaMariaDaFe, name: "Fazenda Maria da Fé", url: "https://fazendamariadafe.com.br" },
  { img: fazendaRoseda, name: "Fazenda Roseda", url: "" },
  { img: fioDeOuro, name: "Fio de Ouro", url: "https://www.instagram.com/azeite.fiodeouro?igsh=bHJrYTh0cG94bzBl" },
  { img: gamarra, name: "Gamarra", url: "https://olivaisgamarra.com.br" },
  { img: grattacielo, name: "Grattacielo", url: "https://www.instagram.com/grattacielomantiqueira?igsh=MWVlNDJnZzQzNXQ2Zw==" },
  { img: machuPicchu, name: "Machu Picchu", url: "https://www.instagram.com/sitio_machupicchu?igsh=Zzk4cjA4amFxcW14" },
  { img: miralua, name: "Miralua", url: "https://www.sitiomiralua.com.br" },
  { img: oliq, name: "Oliq", url: "https://oliq.com.br" },
  { img: olivabr, name: "Oliva BR", url: "" },
  { img: olivaisCatasAltas, name: "Olivais Catas Altas", url: "https://www.instagram.com/olivaiscatasaltasdanoruega?igsh=bmd0b3VpcnN0dmph" },
  { img: olivaisDeQuelemem, name: "Olivais de Quelemém", url: "https://biolinkic.my.canva.site/olivaisdequelemem?fbclid=PAdGRleAODh7tleHRuA2FlbQIxMQBzcnRjBmFwcF9pZA8xMjQwMjQ1NzQyODc0MTQAAadGVXGqXfe3W55g-h4KiUyI-zAghuK6KXW-Z2ov3CkkASm0d3fgaWMlo2CSgw_aem_RcBfoVU41fnyX6IOfY8GJQ" },
  { img: olivasGerais, name: "Olivas Gerais", url: "https://www.instagram.com/olivasgerais?igsh=bW12ZjRkeHpkYXN6" },
  { img: olivasVikaz, name: "Olivas Vikaz", url: "https://www.olivasvikaz.com.br" },
  { img: raiz, name: "Raiz", url: "https://www.instagram.com/azeite.raiz_mantiqueira?igsh=NjBwbzVpNHM2dzdp" },
  { img: sabia, name: "Sabiá", url: "https://lojaazeitesabia.com.br/?srsltid=AfmBOor2VTc4rptI-16Ygz3ptSflf2YglrIQYd4Fy4PC2ovOxL3e_LKE" },
  { img: serraQueChora, name: "Serra que Chora", url: "https://www.azeiteserraquechora.com.br/página-inicial" },
  { img: sitioDaPedra, name: "Sítio da Pedra", url: "https://www.instagram.com/azeitesitiodapedra?igsh=MWY1Z3R1cDloZXQxYg==" },
  { img: solarDaOpera, name: "Solar da Ópera", url: "https://www.instagram.com/solardaoperacafe?igsh=MWxoa2J0anJmZ2Z1bw==" },
  { img: soulMantiqueira, name: "Soul Mantiqueira", url: "https://www.instagram.com/azeitesoulmantiqueira?igsh=NmZnZWJ1eWoxYjdx" },
  { img: trapia, name: "Trapiá", url: "https://www.instagram.com/fazendatrapiaminas?igsh=MmUzb3EwZG42ZDUx" },
  { img: veraCruz, name: "Vera Cruz", url: "https://www.instagram.com/azeiteveracruz?igsh=MTZuaDRrOGkwMzJsdA==" },
  { img: verdeOliva, name: "Verde Oliva", url: "https://fazendaverdeoliva.com.br" },
  { img: veroli, name: "Veroli", url: "https://azeiteveroli.com.br/?srsltid=AfmBOorRt6HDiWHtAfKKmH8O4Q5YbIYMg7vBXuFiUqEzRhEZ5owmOiAB" },
];
const Associados = () => {
  return (
    <section className={styles.generalContent} id="associados">
      <Container>
        <Row>
          <Col xs={12} md={12}>
            <h1 className={styles.tituloAssoolive}>NOSSOS ASSOCIADOS</h1>
          </Col>
        </Row>
        <Row>
          {associados.map((associado, index) => (
            <Col xs={12} md={3} key={index}>
              <div className={styles.contentAssociados}>
                {associado.url ? (
                  <a href={associado.url} target="_blank" rel="noopener noreferrer">
                    <img
                      src={associado.img}
                      alt={associado.name}
                      className={styles.logoParceiros}
                    />
                  </a>
                ) : (
                  <img
                    src={associado.img}
                    alt={associado.name}
                    className={styles.logoParceiros}
                  />
                )}
              </div>
            </Col>
          ))}
        </Row>
        <Row>
        <Col xs={12} md={12}>
            <h2 className={styles.tituloConteudosDeInteresse}>
              CONTEÚDOS DE INTERESSE
            </h2>
            <p className={styles.legendaConteudosDeInteresse}>
              Confira mais fazendo o download dos arquivos a seguir:
            </p>
        </Col>
        <Col xs={12} md={12}>
          <div className={styles.boxArticle}>
            <h3>PREÇO DO AZEITE DE OLIVA: TIRE AQUI SUAS PRINCIPAIS DÚVIDAS</h3>
            <a href="https://www.olibi.com.br/preco-do-azeite-de-oliva/" target="_blank" rel="noreferrer">https://www.olibi.com.br/preco-do-azeite-de-oliva/</a>
          </div>
        </Col>
        <Col xs={12} md={12}>
          <div className={styles.boxArticle}>
            <h3>Consumo de azeite reduz risco de morrer por doenças do coração, diz estudo</h3>
            <a href="https://olhardigital.com.br/2022/01/11/medicina-e-saude/consumo-de-azeite-reduz-risco-de-morrer-por-doencas-do-coracao-diz-estudo/" target="_blank" rel="noreferrer">https://olhardigital.com.br/2022/01/11/medicina-e-saude/consumo-de-azeite-reduz-risco-de-morrer-por-doencas-do-coracao-diz-estudo/</a>
          </div>
        </Col>
        <Col xs={12} md={12}>
          <div className={styles.boxArticle}>
            <h3>EPAMIG anuncia datas do Azeitech 2022</h3>
            <a href="https://epamig.wordpress.com/2022/01/13/epamig-anuncia-data-do-azeitech-2022/" target="_blank" rel="noreferrer">https://epamig.wordpress.com/2022/01/13/epamig-anuncia-data-do-azeitech-2022/</a>
          </div>
        </Col>
        <Col xs={12} md={12}>
          <div className={styles.boxArticle}>
            <h3>Consumption of Olive Oil and Risk of Total and Cause-Specific Mortality Among U.S. Adults</h3>
            <a href="https://www.jacc.org/doi/10.1016/j.jacc.2021.10.041" target="_blank" rel="noreferrer">https://www.jacc.org/doi/10.1016/j.jacc.2021.10.041</a>
          </div>
        </Col>
        <Col xs={12} md={12}>
          <div className={styles.boxArticle}>
            <h3>Aprenda a escolher o AZEITE DE OLIVA ideal</h3>
            <a href="https://www.youtube.com/watch?v=UFeKbpjQWrg" target="_blank" rel="noreferrer">https://www.youtube.com/watch?v=UFeKbpjQWrg</a>
          </div>
        </Col>
        <Col xs={12} md={12}>
          <div className={styles.boxArticle}>
            <h3>Novo podcast da EPAMIG dá dicas para escolha e harmonização de azeites</h3>
            <a href="https://epamig.wordpress.com/2022/01/19/novo-podcast-da-epamig-da-dicas-para-escolha-e-harmonizacao-de-azeites/" target="_blank" rel="noreferrer">https://epamig.wordpress.com/2022/01/19/novo-podcast-da-epamig-da-dicas-para-escolha-e-harmonizacao-de-azeites/</a>
          </div>
        </Col>
        <Col xs={12} md={12}>
          <div className={styles.boxArticle}>
            <h3>Trilhas do Sabor - Ep 55 - Parte 1 - Azeite de Maria da Fé</h3>
            <a href="https://www.youtube.com/watch?v=xIMmrEvquz8&feature=youtu.be" target="_blank" rel="noreferrer">https://www.youtube.com/watch?v=xIMmrEvquz8&feature=youtu.be</a>
          </div>
        </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Associados;
